import React from "react"

type ToggleSwitchProps = {
    checked: boolean
    onChange: (next: boolean) => void
    accentColor: string
    label?: string
    onLabel?: string
    offLabel?: string
    disabled?: boolean
    id?: string
    width?: number
    height?: number
}

export default function ToggleSwitch({
                                         checked,
                                         onChange,
                                         accentColor,
                                         label,
                                         onLabel = "Áno",
                                         offLabel = "Nie",
                                         disabled = false,
                                         id,
                                         width = 46,
                                         height = 24,
                                     }: ToggleSwitchProps) {
    const knob = height - 6
    const left = checked ? width - knob - 3 : 3

    return (
        <div className="d-flex align-items-center">
            {label && <label htmlFor={id}>{label}</label>}

            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    marginLeft: "0.5rem",
                    marginRight: "0.5rem",
                    gap: "0.3rem",
                    fontWeight: 500,
                }}
            >
                <span
                    style={{
                        opacity: checked ? 0.45 : 1,
                        color: checked ? "var(--st-text-faint)" : accentColor,
                        fontSize: "0.85rem",
                        transition: "opacity 0.2s ease, color 0.2s ease",
                    }}
                >
                    {offLabel}
                </span>

                <div
                    id={id}
                    role="switch"
                    aria-checked={checked}
                    tabIndex={disabled ? -1 : 0}
                    onClick={() => !disabled && onChange(!checked)}
                    onKeyDown={(e) => {
                        if (disabled) return
                        if (e.key === "Enter" || e.key === " ") {
                            e.preventDefault()
                            onChange(!checked)
                        }
                    }}
                    style={{
                        width,
                        height,
                        borderRadius: height,
                        backgroundColor: checked ? accentColor : "var(--st-line-strong)",
                        position: "relative",
                        cursor: disabled ? "not-allowed" : "pointer",
                        transition: "background-color 0.2s ease",
                        border: "1px solid transparent",
                    }}
                >
                    <div
                        style={{
                            position: "absolute",
                            top: 3,
                            left,
                            width: knob,
                            height: knob,
                            borderRadius: "50%",
                            backgroundColor: "white",
                            transition: "left 0.2s ease",
                            boxShadow: "0 1px 3px rgba(23,20,31,0.35)",
                        }}
                    />
                </div>

                <span
                    style={{
                        opacity: checked ? 1 : 0.45,
                        color: checked ? accentColor : "var(--st-text-faint)",
                        fontSize: "0.85rem",
                        transition: "opacity 0.2s ease, color 0.2s ease",
                    }}
                >
                    {onLabel}
                </span>
            </div>
        </div>
    )
}
